export default __webpack_public_path__ + "static/media/alarm-24px.df795a76.svg";